import Button from '@material-ui/core/Button';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import {
  accentForCurrency,
  multiplyValueForCurrency,
} from 'utils/currency/currency-utils';
import './index.scss';

const Container = styled.span`
  width: 82px !important;
  height: 26px !important;
  text-align: center;
  border-radius: '4px';
  display: 'flex';
  justify-content: 'center';
  align-items: 'center';
`;

const Label = styled.label`
  font-size: 12px;
  text-align: center;
  font-weight: 700 !important;
  line-height: 18px;
  letter-spacing: 0px;
  font-family: 'Basier Circle';
`;

export let priorityCells = [
  { className: 'booking__time__cell', title: 'Time' },
  { className: 'contact__cell', title: 'Details' },
  { className: 'balance__due__cell', title: 'Deposit' },
  { className: 'order__cell', title: 'Status' },
  { className: 'notes__cell', title: 'Notes' },
  { className: 'order__items__cell', title: 'Ordered Items' },
];

export function getCellContents(
  className,
  booking,
  currency,
  showBookingDetailsModal
) {
  const currencyMultiplier = multiplyValueForCurrency(currency);
  const currencyAccent = accentForCurrency(currency);

  switch (className) {
    case 'booking__time__cell':
      return (
        <div>
          <span style={{ fontWeight: 700 }}>
            {moment(booking.reserved_from).utc().format('h:mm A')}
          </span>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span class="day__text">
              {moment(booking.reserved_from).utc().format('dddd')}
              <br />
              {moment(booking.reserved_from).utc().format('MMMM Do')}
            </span>
          </div>
        </div>
      );
    case 'contact__cell':
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span
            style={{ fontWeight: 700, fontSize: '12px', marginBottom: '4px' }}
          >
            {booking.customer_name}
          </span>
          <div>
            <span
              className="contact-info"
              style={{ fontWeight: 500, fontSize: '10px' }}
            >
              {booking.email}
              <br />
              {booking.phone_number}
            </span>
          </div>
        </div>
      );
    case 'paid__at__cell':
      if (booking.pending) {
        return 'Pending';
      } else
        return moment(booking.reserved_from).format('DD MMM YYYY [at] HH:mm');
    case 'balance__due__cell':
      return (
        <span>
          {currencyAccent}
          {(booking.deposit_amount / currencyMultiplier).toFixed(2)}
        </span>
      );
    case 'order__cell':
      return (
        <Container
          style={{
            backgroundColor:
              booking.paid_at == null
                ? 'rgba(176, 74, 7, 0.2)'
                : 'rgba(36, 181, 149, 0.2)',
            color: booking.paid_at == null ? '#B04A07' : '#115748',
            padding: '3px 2px',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Label>{booking.paid_at == null ? 'Pending' : 'Confirmed'}</Label>
        </Container>
      );
    case 'notes__cell':
      return <span>{booking.notes}</span>;
    case 'order__items__cell':
      if (booking.paid_at) {
        return (
          <Button
            class="fatsoma__cta"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              showBookingDetailsModal(booking.order_identifier);
            }}
          >
            Ordered Items
          </Button>
        );
      }
      break;
    default:
      return '';
  }
}

export function shouldShowCell(cell, venue) {
  // const steps = getVenueSteps(venue);

  switch (cell.className) {
    case 'booking__time__cell':
      return true;
    case 'contact__cell':
      return true;
    case 'paid__at__cell':
      return true;
    case 'balance__due__cell':
      return !venue.require_minimum_spend;
    case 'party__details__cell':
      return false; // steps.hasPartyDetails
    case 'reservations__cell':
      return false; //steps.hasReservations
    case 'order__cell':
      return !venue.hide_menu;
    case 'notes__cell':
      return true;
    case 'order__items__cell':
      return true;
    default:
      return false;
  }
}

export function getCellLabel(className) {
  switch (className) {
    case 'booking__time__cell':
      return 'Date';
    case 'contact__cell':
      return 'Contact';
    case 'balance__due__cell':
      return 'Balance Due';
    case 'paid__at__cell':
      return 'Paid At';
    case 'party__details__cell':
      return 'Party Details';
    case 'reservations__cell':
      return 'Reservations';
    case 'order__cell':
      return 'Order';
    default:
      return '';
  }
}

export function formatOrderItems(booking, currencyMultiplier, currencyAccent) {
  const orderItems = Object.keys(booking.order_items || [])
    .map(index => {
      const orderItem = booking.order_items[index];
      if (!orderItem.children) {
        return 'Legacy Order';
      }

      const formattedItemPrice =
        orderItem.price > 0
          ? `at ${currencyAccent}${(
              orderItem.price / currencyMultiplier
            ).toFixed(2)}`
          : ``;
      const variants = orderItem.children || [];

      const drinkText = `<div class="${
        booking.live ? 'live' : 'preorder'
      } left__border left__border__accent"><span class="quantity__text">${
        orderItem.quantity
      } x</span> ${orderItem.name} ${
        !booking.live ? formattedItemPrice : ''
      } </div>`;

      const variantText = variants
        .map(variant => {
          if (variant.quantity === 0) {
            return '';
          }
          let formattedVariantPrice =
            variant.price > 0 && !booking.live
              ? `at ${currencyAccent}${(
                  variant.price / currencyMultiplier
                ).toFixed(2)}`
              : ``;

          return `<div class="${
            booking.live ? 'live' : 'preorder'
          } left__border left__border__primary left__border__offset-10"> ${
            variant.name
          } ${formattedVariantPrice} </div>`;
        })
        .join('');

      return drinkText + variantText;
    })
    .join('');

  const orderLine =
    orderItems === ''
      ? `<span class="no__order__text">No Order</span>`
      : orderItems;

  return orderLine;
}

var venueSteps = {
  id: '',
  hasBookingTime: false,
  hasReservations: false,
  hasPartyDetails: false,
};

export function getVenueSteps(venue) {
  if (!venue.steps) {
    return venueSteps;
  }

  if (venue.id !== venueSteps.id) {
    venueSteps.hasBookingTime = false;
    venueSteps.hasReservations = false;
    venueSteps.hasPartyDetails = false;

    venue.steps.forEach(step => {
      if (step.type === 'booking-datetime' && step.constraints.include_time) {
        venueSteps.hasBookingTime = true;
      }

      if (step.type === 'table') {
        //venueSteps.hasReservations = true
      }

      if (step.type === 'party-size') {
        //venueSteps.hasPartyDetails = true
      }
    });
  }

  return venueSteps;
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/TableCellGenerator/index.jsx